import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loadingSubject.asObservable();

  private canShowLoader = true;

  showLoading(throttleTime: number = 0) {
    if (this.canShowLoader) {
      this.loadingSubject.next(true);
      this.throttleShowLoading(throttleTime);
    }
  }

  hideLoading() {
    this.loadingSubject.next(false);
  }

  private throttleShowLoading(throttleTime: number) {
    this.canShowLoader = false;
    timer(throttleTime).subscribe(() => {
      this.canShowLoader = true;
    });
  }
}
